export const getFeatureFlagInfo = (state) => state.featureFlagInfo;
